import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

import { ref, computed, onMounted, nextTick, watch } from "vue";

const __default__ = {
  name: "QueueLeafWidget",
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    queueData: {},
    queueConfig: {},
    borderRadius: {},
    config: {},
    numberTxt: {},
    counterTxt: {}
  },
  setup(__props: any) {

const props = __props;

const leafTableRef = ref<HTMLElement | null>(null);
const headerRowRef = ref<HTMLElement | null>(null);
const widgetWidth = computed(() => props.config?.width || 400);
const widgetHeight = computed(() => props.config?.height || 400);
const rowCount = computed(() => props.queueData?.length || 1);
const rowGap = 8;
const headerHeight = ref(50);

onMounted(async () => {
  await nextTick();
  if (headerRowRef.value) {
    headerHeight.value = headerRowRef.value.getBoundingClientRect().height;
  }
});

const isFewRows = computed(() => rowCount.value <= 2);

const availableHeight = computed(() => widgetHeight.value - headerHeight.value);

// const headerFontSize = computed(() => {
//   return Math.max(18, Math.min(40, widgetWidth.value * 0.10, widgetHeight.value * 0.10));
// });

const headerFontSize = computed(() => {
  if(props.config.queueConfig.headerFontSize && props.config.queueConfig.headerFontSize !== 0 && props.config.queueConfig.headerFontSize !== '0' && props.config.queueConfig.headerFontSize !== null && props.config.queueConfig.headerFontSize !== undefined){
    return props.config.queueConfig.headerFontSize;
  }
  const w = widgetWidth.value;
  const h = headerHeight.value;
  //smaller of 10% of width or 60% of header height, with reasonable min/max
  return Math.max(18, Math.min(55, Math.min(w * 0.10, h * 0.6)));
});

const rowFontSize = computed(() => {
  if(props.config.queueConfig.contentFontSize && props.config.queueConfig.contentFontSize !== 0 && props.config.queueConfig.contentFontSize !== '0' && props.config.queueConfig.contentFontSize !== null && props.config.queueConfig.contentFontSize !== undefined){
    return props.config.queueConfig.contentFontSize;
  }
  const w = widgetWidth.value / 2;
  const h = (availableHeight.value - (rowCount.value - 1) * rowGap) / rowCount.value;
  const maxFont = isFewRows.value ? 70 : 120;
  return Math.max(18, Math.min(maxFont, h * 0.4, w * 0.4));
});

const numberCellStyle = computed(() => ({
  background: props.queueConfig?.numberBgColor || "#2c4a7a",
  color: props.queueConfig?.numberTxtColor || "#fff",
  minWidth: "90px",
  borderRadius: typeof props.borderRadius === "number" ? `${props.borderRadius}px` : "0",
}));

const counterCellStyle = computed(() => ({
  background: props.queueConfig?.counterBgColor || "#ffb300",
  color: props.queueConfig?.counterTxtColor || "#fff",
  padding: "0.2em 0.2em 0.2em 0.7em",
  minWidth: "50px",
  borderRadius: typeof props.borderRadius === "number" ? `${props.borderRadius}px` : "0",
}));

const leafTableStyle = computed(() => ({
  width: "100%",
  height: "100%",
  borderRadius: typeof props.borderRadius === "number" ? `${props.borderRadius}px` : "0",
  overflow: "hidden",
}));

const numberFlex = computed(() => {
  if (props.config?.width <= 400) return 1.3;
  if (props.config?.width < 500) return 1.5;
  return 2;
});
const counterFlex = computed(() => 1);


const language = computed(() => {
  return localStorage.getItem("Language");
});

const headerTextAlign = computed(() => (language.value === 'ar' ? 'center' : 'start'));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "leaf-table",
    ref_key: "leafTableRef",
    ref: leafTableRef,
    style: _normalizeStyle(leafTableStyle.value)
  }, [
    _createElementVNode("div", {
      class: "leaf-header-row",
      ref_key: "headerRowRef",
      ref: headerRowRef
    }, [
      _createElementVNode("div", {
        class: "leaf-header",
        style: _normalizeStyle({ color: _ctx.queueConfig.numberHeaderColor, fontSize: headerFontSize.value + 'px', textAlign: headerTextAlign.value })
      }, _toDisplayString(_ctx.numberTxt.toUpperCase()), 5),
      _createElementVNode("div", {
        class: "leaf-header",
        style: _normalizeStyle({ color: _ctx.queueConfig.counterHeaderColor, fontSize: headerFontSize.value + 'px', textAlign: headerTextAlign.value })
      }, _toDisplayString(_ctx.counterTxt.toUpperCase()), 5)
    ], 512),
    _createElementVNode("div", {
      class: _normalizeClass(["leaf-rows", { 'few-rows': isFewRows.value }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.queueData, (row, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: row.id || idx,
          class: "leaf-row"
        }, [
          _createElementVNode("div", {
            class: "leaf-cell leaf-number-cell",
            style: _normalizeStyle({ ...numberCellStyle.value, flex: numberFlex.value, fontSize: rowFontSize.value + 'px' })
          }, _toDisplayString(row.ticket), 5),
          _createElementVNode("div", {
            class: "leaf-cell leaf-counter-cell",
            style: _normalizeStyle({ ...counterCellStyle.value, flex: counterFlex.value, fontSize: rowFontSize.value + 'px' })
          }, _toDisplayString(row.counter), 5)
        ]))
      }), 128))
    ], 2)
  ], 4))
}
}

})